import getConstants from '../../constants'
import { reqError, isReqError } from '../Request/error'

export type GetWordingProps = {
  country: string
  currentVersion: string
  stableVersion: string
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''
const CONSTANTS = getConstants()

export const getLocalisationDiff = async ({
  country,
  currentVersion,
  stableVersion,
}: GetWordingProps) => {
  const lang = CONSTANTS.LANGUAGE
  const response = await fetch(
    `${API_BASE_URL}/${country}/${lang}/wordings/json/${stableVersion}/${currentVersion}.json`,
  )
  const { status: statusCode } = response
  const json = await response.json()

  if (isReqError(statusCode)) {
    throw reqError(statusCode, json.message)
  }

  return json
}
